<template>
  <div class="main-error">
    <b-row>
      <b-col cols="12">
        <h1>404</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <p>Desculpe, a página que você tentou acessar não pode ser encontrada.</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-button class="btn-error" href="/">
          <span>Home</span>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'Error404'
}
</script>

<style lang="scss" scoped>
.main-error {
  font-family: 'Open Sans', sans-serif;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 450px;
  background-color: #f6f6f6;

  h1 {
    font-size: 325px;
    font-weight: 800;
    color: #3B1953;
    line-height: 285px;
    letter-spacing: -0.088em;
  }
  p {
    font-size: 18px;
    letter-spacing: -0.04em;
    font-weight: 700;
    color: #3B1953;
  }
  .btn-error {
    margin-top: 20px;
    background: transparent;
    border-color: #3B1953;
    border: 2px solid #3B1953;
    padding: 10px 75px;

    span {
      color: #3B1953;
      text-transform: uppercase;
      font-weight: 600;
    }
    &:hover {
      background-color: #3B1953;
      box-shadow: 0px 0px 15px rgba($color: #000000, $alpha: 0.3);
      transition: all 0.5s ease-in-out;
      span {
        color: #ffffff;
      }
    }
    &:focus {
      box-shadow: none;
    }
  }
}

@media (min-width: 992px) and (max-width: 1200px) {
  .main-error {
  margin-bottom: 50px;
  font-family: 'Open Sans', sans-serif;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 450px;

  h1 {
    font-size: 255px;
    font-weight: 800;
    color: #3B1953;
    line-height: 285px;
  }
  p {
    font-size: 18px;
    letter-spacing: -0.04em;
    font-weight: 700;
    color: #3B1953;
    text-align: center;
  }
  .btn-error {
    margin-top: 20px;
    background: transparent;
    border-color: #3B1953;
    border: 2px solid #3B1953;
    padding: 10px 75px;

    span {
      color: #3B1953;
      text-transform: uppercase;
      font-weight: 600;
    }
  }
}
}
@media (min-width: 768px) and (max-width: 992px) {
  .main-error {
  margin-bottom: 50px;
  font-family: 'Open Sans', sans-serif;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 450px;

  h1 {
    font-size: 255px;
    font-weight: 800;
    color: #3B1953;
    line-height: 285px;
  }
  p {
    font-size: 18px;
    letter-spacing: -0.04em;
    font-weight: 700;
    color: #3B1953;
    text-align: center;
  }
  .btn-error {
    margin-top: 20px;
    background: transparent;
    border-color: #3B1953;
    border: 2px solid #3B1953;
    padding: 10px 75px;

    span {
      color: #3B1953;
      text-transform: uppercase;
      font-weight: 600;
    }
  }
}
}
@media (min-width: 576px) and (max-width: 768px) {
  .main-error {
  margin-bottom: 50px;
  font-family: 'Open Sans', sans-serif;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 450px;

  h1 {
    font-size: 255px;
    font-weight: 800;
    color: #3B1953;
    line-height: 285px;
  }
  p {
    font-size: 18px;
    letter-spacing: -0.04em;
    font-weight: 700;
    color: #3B1953;
    text-align: center;
  }
  .btn-error {
    margin-top: 20px;
    background: transparent;
    border-color: #3B1953;
    border: 2px solid #3B1953;
    padding: 10px 75px;

    span {
      color: #3B1953;
      text-transform: uppercase;
      font-weight: 600;
    }
  }
}
}
@media (min-width: 320px) and (max-width: 576px) {
  .main-error {
  margin-bottom: 50px;
  font-family: 'Open Sans', sans-serif;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 450px;

  h1 {
    font-size: 255px;
    font-weight: 800;
    color: #3B1953;
    line-height: 285px;
  }
  p {
    font-size: 18px;
    letter-spacing: -0.04em;
    font-weight: 700;
    color: #3B1953;
    text-align: center;
  }
  .btn-error {
    margin-top: 20px;
    background: transparent;
    border-color: #3B1953;
    border: 2px solid #3B1953;
    padding: 10px 75px;

    span {
      color: #3B1953;
      text-transform: uppercase;
      font-weight: 600;
    }
  }
}
}
</style>